import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import ClearIcon from "@mui/icons-material/Clear";
import { BsPlusLg } from "react-icons/bs";
import PreviewModal from "./PreviewModal";
import Slide from "@mui/material/Slide";
import CircularProgress from "@mui/material/CircularProgress";
import {
  aircraftAutolog,
  getAircraft,
  getFlightData,
  getFlightbyDate,
  // getFlightbyDate,
} from "../Axios/Axios";
import AddFlightManual from "./AddFlightManual";
import AddAircraftModal from "./AddAircraftModal";
import { ToastContainer, toast } from "react-toastify";
const style = {
  position: "fixed",
  top: "0",
  right: "0",
  width: "60%",
  height: "900px",
  maxWidth: "500px",
  maxHeight: "100%",
  bgcolor: "white",
  boxShadow: 24,
  paddingLeft: "5%",
  paddingRight: "3%",
  overflow: "auto",
  zIndex: 9999,

  "&::-webkit-scrollbar": {
    //Beautifying scrollbar
    width: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
};

interface AddFlightModalProps {
  open: boolean;
  onCloseFm: () => void;
  onOpenManual: () => void;
  // landingsprop: number;
}

function AddFlightModal({
  open,
  onCloseFm,
  onOpenManual,
}: AddFlightModalProps) {
  const [crewPositions, setCrewPositions] = useState<
    { label: string; value: string }[]
  >([]);
  const [userInput, setUserInput] = useState<UserInput>({}); // Use the UserInput type

  const [aircraftIndex, setAircraftIndex] = useState(-1);
  const [showFromToFields, setShowFromToFields] = useState(false);
  const [selectedAircraft, setSelectedAircraft] = useState<string>("");
  const [formsubmit, setFormSubmit] = React.useState(false);
  const [userName, setUserName] = useState("");
  const [aircraftData, setAircraftData] = useState<any>([]);
  const [aircraftModels, setAircraftModels] = useState<any>([]);
  const [flightId, setFlightId] = useState("");
  const [flightNumber, setFlightNumber] = useState("");
  const [fromLoc, setFromLoc] = useState("");
  const [toLoc, setToLoc] = useState("");
  const [actualIn, setActualIn] = useState("");
  const [actualOut, setActualOut] = useState("");
  const [actualOn, setActualOn] = useState("");
  const [actualOff, setActualOff] = useState("");
  const [date, setDate] = useState("");
  const [totalTime, setTotalTime] = useState(0.0);
  const [day, setDay] = useState<number>(0.0);
  const [night, setNight] = useState<number>(0.0);
  const [route, setRoute] = useState("");
  const [fromCity, setFromcity] = useState("");
  const [toCity, setTocity] = useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [autolog,setAutolog]=React.useState(false);
  const [instrumentTimePercentageCheck, setInstrumentTimePercentageCheck] =
    useState("");

  const [approachesCheck, setApproachesCheck] = useState("");
  // const [identIcao, setIdentIcao] = useState<any>([]);

  const [instrumentTimePercentageInput, setInstrumentTimePercentageInput] =
    useState("");
  const [approachesInput, setApproachesInput] = useState("");
  interface CrewOption {
    label: string;
  }
  const [crewOptionsPresent, setCrewOptionsPresent] = useState<
    Array<Array<CrewOption>>
  >([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [landingCheck, setLandingCheck] = useState("");
  const [landingDay, setLandingDay] = useState(0);
  const [landingNight, setLandingNight] = useState(0);

  const [takesOffDay, setTakesOffDay] = useState(0);
  const [takesOffNight, setTakesOffNight] = useState(0);
  
  const [aircraftDefault, setAircraftDefault] = useState([]);
  const [aircraftModelsDefaut, setAircraftModelsDefault] = useState("");
  const [toggleState, setToggleState] = React.useState({
    auto: true,
  });
  const [isAutoMode, setIsAutoMode] = useState(true);
  const [isToggled, setIsToggled] = useState(false);
  const [
    autofilledValueInstrumentTimePercent,
    setAutofilledValueInstrumentTimePercent,
  ] = useState("");
  const [addAircraft, setAddAircraft] = React.useState(false);

  const [registrationNo, setRegistrationNo] = useState("");
  const [aircarftid, setAircarftid] = React.useState("");
  const [aircraftType, setAircraftType] = React.useState("");
  const [remarks, setRemarks] = React.useState("");
  const [crossCountry,setCrossCountry]=React.useState(false);
  const [crossCountryTime,setCrossCountryTime]=React.useState<number>(0);
  const [routeDistance,setRouteDistance]=React.useState<number>(0);
  const [departureDelay,setDepartureDelay]=React.useState<number>(0);
  const [arrivalDelay,setArrivalDelay]=React.useState<number>(0);

  const handleAddAircraft = () => {
    setAddAircraft(true);
  };

  const handleCloseAircraft = () => {
    setAddAircraft(false);
  };

  const handleInstrumentTimePercentageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setInstrumentTimePercentageInput(event.target.value);
  };

  const calculateAutofilledValueInstrumentTimePercent = () => {
    const percentage = parseFloat(instrumentTimePercentageInput);
    if (!isNaN(percentage)) {
      const calculatedValue = (percentage / 100) * totalTime;
      setAutofilledValueInstrumentTimePercent(calculatedValue.toFixed(2));
    }
  };

  React.useEffect(() => {
    calculateAutofilledValueInstrumentTimePercent();
    console.log("called")
  }, [instrumentTimePercentageInput,totalTime]);

  const resetAllStates = () => {
    setCrewPositions([]);
    setUserInput({});
    setAircraftIndex(-1);
    setShowFromToFields(false);
    setSelectedAircraft("");
    setFormSubmit(false);
    setAircraftData([]);
    setAircraftModels([]);
    setFlightId("");
    setFlightNumber("");
    setFromLoc("");
    setToLoc("");
    setActualIn("");
    setActualOut("");
    setActualOn("");
    setActualOff("");
    setDate("");
    setTotalTime(0);
    setDay(0);
    setNight(0);
    setRoute("");
    setFromcity("");
    setTocity("");
    setLoading(false);
    setError("");
    setInstrumentTimePercentageCheck("");
    setApproachesCheck("");
    setInstrumentTimePercentageInput("");
    setApproachesInput("");
    setCrewOptionsPresent([]);
    setIsModalOpen(false);
    setLandingCheck("");
    setLandingDay(0);
    setLandingNight(0);
    setTakesOffDay(0);
    setTakesOffNight(0);
    setAircraftDefault([]);
    setAircraftModelsDefault("");
    setToggleState({ auto: true });
    setIsAutoMode(true);
    setIsToggled(false);
    setCrossCountry(false);
  };

  const updateCrewPosition = (inputName: string, inputValue: string) => {
    const updatedCrewPositions = crewPositions.map((position) =>
      position.label === inputName
        ? { ...position, value: inputValue }
        : position
    );
    setCrewPositions(updatedCrewPositions);
  };

  const toggleMode = () => {
    setIsAutoMode(!isAutoMode);
  };
  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsToggled(!isToggled);
    setToggleState({
      ...toggleState,
      [event.target.name]: event.target.checked,
    });
  };
  type UserInput = {
    [key: string]: string;
  };


  //AutoFill form through flight number
  const handleFlightNumber = async () => {
    if (flightNumber) {
      setLoading(true);
      try {
        const data2 = await getFlightData(flightNumber);
        console.log("flight data",data2)
        setSelectedAircraft(data2.data.flights[0].aircraft_type)
        if(data2.data.flights[0].aircraft_type===null){
         setSelectedAircraft(data2.data.flights[0].registration) 
        }
 
        setRegistrationNo(data2.data.flights[0].registration);
        setAircraftType(data2.data.flights[0].aircraft_type);
        if(data2.data.flights[0].aircraft_type===null){
          setAircraftType(data2.data.flights[0].registration);
        }
        if(data2.data.flights[0].aircraft_type===null){
          setAircraftType(data2.data.flights[0].registration);
        }
        setFlightId(data2.data.flights[0].ident);
        setActualIn(data2.data.flights[0].actual_in);
        if(data2.data.flights[0].actual_in===null){
          setActualIn(data2.data.actual_in)
        }
        setActualOut(data2.data.flights[0].actual_out);
        setActualOn(data2.data.flights[0].actual_on);
        setActualOff(data2.data.flights[0].actual_off);
        setFromLoc(data2.data.flights[0].origin.code_icao);
        setToLoc(data2.data.flights[0].destination.code_icao);
        // const totalTimeInHours = (data2.data.totalTimeMinutes/60).toFixed(2);
        setTotalTime(parseFloat(data2?.data?.totalTimehours || 0));
        setDate(data2.data.dateToday);
        setRoute(data2.data.flights[0].route);
        setRouteDistance(data2.data.flights[0].route_distance);
        setDepartureDelay(data2.data.flights[0].departure_delay);
        setArrivalDelay(data2.data.flights[0].arrival_delay);
        console.log("data222222:", data2.data);
        setLoading(false);
        setError("  ");
      } catch (error) {
        console.error(error);
        setLoading(false);
        setTimeout(() => {
          setError("Data not found*");
        }, 5000);  
      }
      setTimeout(() => {
        setError("");
      }, 60000); 

    }
  };


  React.useEffect(() => {
    handleFlightNumber();
  }, [flightNumber]);

  const handleOpenPreview = () => {
    setIsModalOpen(true);
  };
  const handleClosePreview = () => {
    setIsModalOpen(false);
  };
  const handleCloseFlightModal = () => {
    setIsModalOpen(false);
  };

  const handleDayBlur = () => {
    const dayValue = typeof day === "number" ? day : parseFloat(day); // Convert to float
    const remainingTime = Number(totalTime) - dayValue;
    if (!isNaN(remainingTime) && remainingTime >= 0) {
      const roundedNight = parseFloat(remainingTime.toFixed(2));
      setNight(roundedNight);
    }
  };
  
  const handleNightBlur = () => {
    const nightValue = typeof night === "number" ? night : parseFloat(night); // Convert to float
    const remainingTime = Number(totalTime) - nightValue;
    if (!isNaN(remainingTime) && remainingTime >= 0) {
      const roundedDay = parseFloat(remainingTime.toFixed(2));
      setDay(roundedDay);
    }
  };

  const handleUserInputBlur = (label:any, value:any) => {
    setUserInput({
      ...userInput,
      [label]: value,
    });
  };
  

  const handleCrossCountry = (event: any) => {
    setCrossCountry(!crossCountry);
    if(crossCountry===true)
    {
    setCrossCountryTime(totalTime);
    }
    console.log(crossCountry);
   
  };

  const handleTotalTime = (e:any) => {
    const newValue = Number(e.target.value);

    // Assuming you want to set both totalTime and crossCountryTime to the same value
    setTotalTime(newValue);
    if(crossCountry===true)
    {
    setCrossCountryTime(newValue);
    }
    console.log(crossCountryTime)
  };
  

  //To Open Full form onClick
  const handleShowFromToFields = () => {
    setShowFromToFields(!showFromToFields);
  };

  //Aircraft model selection from dropdown
  const handleAircraftChange = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    resetAllStates();

    setSelectedAircraft(e.target.value);
    // console.log(e.target.value);

    try {
      const selectedIndex =
        e.target.options[e.target.selectedIndex].getAttribute("data-index");
      if (selectedIndex !== null) {
        // Convert selectedIndex to a number (it's a string by default)
        const index = parseInt(selectedIndex, 10);
        setAircraftIndex(index);
        const data = aircraftData[index];
        console.log("Dataaaaaa:", data);
        setRegistrationNo(data.registrationNo);
        setAircarftid(data._id);
        const data1= await aircraftAutolog(data._id);
        setAutolog(data1.even);
        setAircraftType(data.model);
      if(data1.even===true)
        {setInstrumentTimePercentageInput(data.instrumentTimePercentage);
        setApproachesInput(data.approaches);}
        else{
          setInstrumentTimePercentageInput(e.target.value);
          setApproachesInput(e.target.value);
        }

        if (data1.even===true) {
          setTakesOffDay(1);
          setLandingDay(1);
        }
        else {
          setTakesOffDay(Number(e.target.value));
          setLandingDay(Number(e.target.value));
        }
        setCrewOptionsPresent(data.defaultCrewPosition);
        const data2 = await getFlightData(data.registrationNo);
        console.log("dataaaaa",data2)
        setFlightId(data2.data.flights[0].ident);
        setFlightNumber(data2.data.flights[0].ident);
        setActualIn(data2.data.flights[0].actual_in);
        if(data2.data.flights[0].actual_in===null){
          setActualIn(data2.data.actual_in)
        }
        setActualOut(data2.data.flights[0].actual_out);
        setActualOn(data2.data.flights[0].actual_on);
        setActualOff(data2.data.flights[0].actual_off);
        setFromLoc(data2.data.flights[0].origin.code_icao);
        setToLoc(data2.data.flights[0].destination.code_icao);
        setFromcity(data2.data.flights[0].origin.city);
        setTocity(data2.data.flights[0].destination.city);
        // const totalTimeInHours = (data2.data.totalTimeMinutes/60).toFixed(2);
        setTotalTime(parseFloat(data2?.data?.totalTimehours || 0));
        setDate(data2.data.dateToday);
        setRoute(data2.data.flights[0].route);
        setRouteDistance(data2.data.flights[0].route_distance);
        setDepartureDelay(data2.data.flights[0].departure_delay);
        console.log("autolog",data1)
        console.log("even",data1.even)
      }
    } catch (error) {
      console.error(error);
    }
  };


  //Fetching Aircraft Data
  React.useEffect(() => {
    // Define a flag to prevent the effect from running when aircraftModels change
    let shouldRunEffect = true;

    async function fetchData() {
      try {
        const data = await getAircraft();
        // const data4: any = await getAircraftdefault(data2);
        // setAircraftDefault(data4);
        const data3 = data;
        setAircraftData(data3);
        console.log("data of aircraft", data3); // Aircraft data

        if (shouldRunEffect) {
          const updatedAircraftModels = data3.map(
            (entry: any) => entry.model
          );
          setAircraftModels(updatedAircraftModels);
        }
      } catch (error) {
        console.error("Error fetching aircraft data:", error);
        // Handle errors as needed (e.g., show an error message)
      }
    }

    fetchData();

    // Return a cleanup function to reset the flag when the component unmounts
    return () => {
      shouldRunEffect = false;
    };
  }, []);
  

//Update by date change
  React.useEffect(() => {
    let shouldRunEffect = true;

    async function fetchDatabyDate() {
      try {
        console.log(flightId, date);
        const data = { id: flightNumber, startDate: date };
        const data2 = await getFlightbyDate(data);
        console.log("my data", data2);
        // setFlightId(data2.data.flights[0].ident);
        // setFlightNumber(data2.data.flights[0].identIcao);
        setActualIn(data2.data.flights[0].actual_in);
        if(data2.data.flights[0].actual_in===null){
          setActualIn(data2.data.actual_in)
        }
        setActualOut(data2?.data?.flights[0]?.actual_out);
        setActualOn(data2?.data?.flights[0]?.actual_on);
        setActualOff(data2?.data?.flights[0]?.actual_off);
        setFromLoc(data2?.data?.flights[0]?.origin?.code_icao);
        setToLoc(data2?.data?.flights[0]?.destination?.code_icao);
        setFromcity(data2?.data?.flights[0]?.origin?.city);
        setTocity(data2?.data?.flights[0]?.destination?.city);
        // const totalTimeInHours = data2.data.totalTime;
        setTotalTime(parseFloat(data2?.data?.totalTimehours || 0));
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle errors as needed (e.g., show an error message)
      }
    }

    fetchDatabyDate();

    return () => {
      shouldRunEffect = false;
    };
  }, [date]);


  const handleKeyPress = (e:any) => {
    // Check if the pressed key is Enter (key code 13)
    if (e.key === 'Enter') {
      // Check if the event target is not an input element inside the modal
      if (!e.target.closest('.modal input')) {
        // Prevent the modal switch logic from executing
        e.preventDefault();
      }
    }
  };


  return (
    <Modal open={open} onClose={onCloseFm} onKeyPress={handleKeyPress}>
      <Slide direction="left" in={open} mountOnEnter unmountOnExit>
        <Box sx={style}>
          <form action="">
            <div>
              <div className="clear_icon">
                <ClearIcon style={{ marginTop: "2%" }} onClick={onCloseFm} />
              </div>
              <h2 className="heading2">Add New Flight</h2>
              <p className="heading4 secondary" style={{ fontWeight: "600" }}>
                Flight Details
              </p>
              <div
                className="f-flex"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <label className="heading5" style={{ marginBottom: "5px" }}>
                  Flight
                </label>

                <div>
                  <button
                    className="add_flight_btn"
                    style={{
                      marginBottom: "15px",
                      background: "#F69110",
                      marginLeft: "90%",
                    }}
                    onClick={() => {
                      onOpenManual();

                      // onClose();
                    }}
                  >
                    <span>Auto</span>
                  </button>
                </div>

                <button
                  onClick={handleAddAircraft}
                  type="button"
                  className="add_flight_btn"
                  style={{ marginBottom: "15px", marginLeft: "20%" }}
                >
                  <BsPlusLg /> Add Aircraft
                </button>
                {/* Add New AirCraft Form  */}
                <AddAircraftModal
                  open={addAircraft}
                  onClose={handleCloseAircraft}
                />
              </div>
              <div
                className="add_group"
                style={{ width: "100%", position: "relative" }}
              >
                <input
                  type="text"
                  className="add_input"
                  placeholder="Select Aircraft"
                  value={selectedAircraft}
                  style={{ zIndex: 2 }}
                />
                <select
                  className="add_input"
                  value={selectedAircraft}
                  onChange={handleAircraftChange}
                >
                  <option value="">
                    Select your Aircraft
                  </option>
                  {aircraftModels.map((model: any, index: any) => (
                    <option key={index} value={model} data-index={index}>
                      {model}
                    </option>
                  ))}
                </select>
              </div>
              <div className="f-flex">
                <label
                  className="heading5"
                  style={{
                    marginBottom: "5px",
                    display: "flex",
                    flexGrow: "1",
                  }}
                >
                  Flight Number
                </label>
                <label
                  className="heading5"
                  style={{
                    marginBottom: "5px",
                    display: "flex",
                    flexGrow: "1",
                    marginRight: "10%",
                  }}
                >
                  Date
                </label>
              </div>
              {error && (
                <div
                  style={{ color: "red", marginTop: "4px" }}
                  className="heading6"
                >
                  {error}
                </div>
              )}{" "}
              {/* Error display */}
              <div className="f-flex">
                <div
                  className="add_group"
                  style={{ display: "flex", flexGrow: "1" }}
                >
                  <input
                    type="text"
                    placeholder="UTF3235"
                    className="add_input"
                    value={flightNumber}
                    onChange={(e) => setFlightNumber(e.target.value)}
                  />
                  {loading && <CircularProgress size={20} />}{" "}
                </div>
                <div
                  className="add_group"
                  style={{ display: "flex", flexGrow: "1" }}
                >
                  <input
                    type="date"
                    placeholder="Select"
                    className="add_input"
                    onChange={(e) => setDate(e.target.value)}
                    value={date}
                  />
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button
                  type="button"
                  onClick={handleShowFromToFields}
                  className="add_flight_btn"
                  style={{ width: "90px" }}
                >
                  {showFromToFields ? "Hide" : "Show more"}
                </button>
              </div>
              {showFromToFields && (
                <div>
                  <div className="f-flex">
                    <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                      From
                    </label>
                    <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                      To
                    </label>
                  </div>
                  <div className="f-flex">
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="UK"
                        className="add_input"
                        value={fromLoc}
                        onChange={(e) => setFromLoc(e.target.value)}
                      />
                    </div>
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="USA"
                        className="add_input"
                        value={toLoc}
                        onChange={(e) => setToLoc(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="f-flex">
                    <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                      Out (UTC)
                    </label>
                    <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                      In (UTC)
                    </label>
                  </div>
                  <div className="f-flex">
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="+9:00"
                        className="add_input"
                        value={actualOut}
                        onChange={(e) => setActualOut(e.target.value)}
                      />
                    </div>
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="+12:00"
                        className="add_input"
                        value={actualIn}
                        onChange={(e) => setActualIn(e.target.value)}
                      />
                    </div>
                  </div>
                  {/* instrument Time Percentage end  */}
                  <p
                    className="heading4 secondary"
                    style={{ fontWeight: "600" }}
                  >
                    TIME
                  </p>
                  <div className="add_span" style={{ flexGrow: "1" }}>
                  <input
                    type="checkbox"
                    className="add_checkbox"
                    id="cross_country"
                    name="cross_country"
                    onChange={handleCrossCountry}
                    checked={crossCountry}
                  />
                  <label className="heading5">Cross Country</label>
                </div>
                  <div style={{ display: "flex", flexGrow: "1" }}>
                    <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                      Total Time
                    </label>
                    <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                      Day
                    </label>
                    <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                        marginLeft: "7%",
                      }}
                    >
                      Night
                    </label>
                  </div>
                  <div className="f-flex">
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="hours"
                        className="add_input"
                        value={totalTime === 0 ? "" : totalTime}
                        onChange={handleTotalTime}
                      />
                    </div>
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="hours"
                        className="add_input"
                        value={day === 0 ? "" : day}
                        onChange={(e) => setDay(Number(e.target.value))}
                        onBlur={handleDayBlur}
                      />
                    </div>
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="hours"
                        className="add_input"
                        value={night === 0 ? "" : night}
                        onChange={(e) => setNight(Number(e.target.value))}
                        onBlur={handleNightBlur}
                      />
                    </div>
                  </div>
              
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      marginBottom: "1rem",
                      gap: "5%",
                    }}
                  >
                    {crewOptionsPresent &&
                    crewOptionsPresent[0] &&
                    crewOptionsPresent[0].length > 0 ? (
                      crewOptionsPresent[0].map((option) => (
                        <div
                          style={{
                            fontWeight: "400",
                          }}
                          className="heading5"
                          key={option.label} // Add a unique key for each element
                        >
                          {option.label}
                          {crewOptionsPresent[0].length > 1 ? (
                            <input
                              className="add_group"
                              style={{
                                display: "flex",
                                width: "80%",
                                WebkitAppearance: "none",
                              }}
                              type="text"
                              placeholder={option?.label}
                              onChange={(e) => {
                                setUserInput({
                                  ...userInput,
                                  [option.label]: e.target.value,
                                  
                                });
                                console.log("User",userInput);
                              }}
                            />
                          ) : (
                            <input
                              className="add_group"
                              style={{
                                display: "flex",
                                width: "80%",
                              }}
                              type="text"
                              // placeholder={totalTime}
                              value={
                                userInput[option.label] == undefined
                                  ? userInput[option.label]
                                  : totalTime
                              }
                              onChange={(e) => {
                                setUserInput({
                                  ...userInput,
                                  [option.label]: e.target.value,
                                });
                              }}
                              onBlur={()=>handleUserInputBlur(option.label,totalTime)}
                              // disabled
                              // inputMode="none"
                            />
                          )}
                        </div>
                      ))
                    ) : (
                      <>
                        <div
                          style={{
                            fontWeight: "400",
                          }}
                          className="heading5"
                          // Add a unique key for each element
                        >
                          PIC
                          <input
                            className="add_group"
                            style={{
                              display: "flex",
                              width: "80%",
                              WebkitAppearance: "none",
                            }}
                            type="text"
                            placeholder="PIC"
                            onChange={(e) => {
                              setUserInput({
                                ...userInput,
                                "PIC": e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div
                          style={{
                            fontWeight: "400",
                          }}
                          className="heading5"
                        >
                          SIC
                          <input
                            className="add_group"
                            style={{
                              display: "flex",
                              width: "80%",
                              WebkitAppearance: "none",
                            }}
                            type="text"
                            placeholder="SIC"
                            onChange={(e) => {
                              setUserInput({
                                ...userInput,
                                "SIC": e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div
                          style={{
                            fontWeight: "400",
                          }}
                          className="heading5"
                          // Add a unique key for each element
                        >
                          EP
                          <input
                            className="add_group"
                            style={{
                              display: "flex",
                              width: "80%",
                              WebkitAppearance: "none",
                            }}
                            type="text"
                            placeholder="EP"
                            onChange={(e) => {
                              setUserInput({
                                ...userInput,
                                "EP": e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div
                          style={{
                            fontWeight: "400",
                          }}
                          className="heading5"
                        >
                          IP
                          <input
                            className="add_group"
                            style={{
                              display: "flex",
                              width: "80%",
                              WebkitAppearance: "none",
                            }}
                            type="text"
                            placeholder="IP"
                            onChange={(e) => {
                              setUserInput({
                                ...userInput,
                                "IP": e.target.value,
                              });
                              console.log("User input",userInput)
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div style={{ display: "flex" }}>
                    <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                      Takeoffs
                    </label>
                    <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                      Landings
                    </label>
                  </div>
                  <div className="f-flex" style={{ gap: "8px" }}>
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      {autolog===true ? (
                        <input
                          style={{ background: "transparent" }}
                          type="text"
                          placeholder="Day"
                          className="add_input"
                          value="1"
                          // disabled
                        />
                      ) : (
                        <input
                          type="text"
                          placeholder="Day"
                          className="add_input"
                          value={takesOffDay? takesOffDay:""}
                          onChange={(e) => setTakesOffDay(Number(e.target.value))}
                        />
                      )}
                    </div>

                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="Night"
                        className="add_input"
                        value={takesOffNight ? takesOffNight:""}
                        onChange={(e) => setTakesOffNight(Number(e.target.value))}
                      />
                    </div>

                    <div className="f-flex" style={{ gap: "8px" }}>
                      <div
                        className="add_group"
                        style={{ display: "flex", flexGrow: "1" }}
                      >
                        {autolog===true  ? (
                          <input
                            style={{ background: "transparent" }}
                            type="text"
                            placeholder="Day"
                            className="add_input"
                            value="1"
                            // disabled
                          />
                        ) : (
                          <input
                            type="text"
                            placeholder="Day"
                            className="add_input"
                            value={landingDay? landingDay:""}
                            onChange={(e) => setLandingDay(Number(e.target.value))}
                          />
                        )}
                      </div>
                      <div
                        className="add_group"
                        style={{ display: "flex", flexGrow: "1" }}
                      >
                        <input
                          type="text"
                          placeholder="Night"
                          className="add_input"
                          value={landingNight? landingNight:""}
                          onChange={(e) => setLandingNight(Number(e.target.value))}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                     { autolog===true ?
                     (<div>
                        <p className="heading5">Approaches</p>
                        <input
                          className="add_group"
                          style={{ width: "180%" }}
                          type="text"
                          placeholder="Enter"
                          value={approachesInput}
                          onChange={(e) => setApproachesInput(e.target.value)}
                        />
                      </div>):
                      (
                         <div>
                         <p className="heading5">Approaches</p>
                         <input
                           className="add_group"
                           style={{ width: "180%" }}
                           type="text"
                           placeholder="Enter"
                           onChange={(e) => setApproachesInput(e.target.value)}
                         />
                       </div>
                      )}
      
                    {/* Approaches end */}

                    {/* Instrument Time Percentage */}
                     {autolog===true ?
                     ( <div style={{ marginLeft: "25%" }}>
                        <p className="heading5">Instrument Time %</p>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <input
                            style={{ width: "50%" }}
                            className="add_group"
                            type="text"
                            placeholder="%"
                            value={instrumentTimePercentageInput}
                            onChange={handleInstrumentTimePercentageChange}
                            onBlur={
                              calculateAutofilledValueInstrumentTimePercent
                            }
                          />

                          <input
                            style={{ width: "50%" }}
                            className="add_group"
                            type="text"
                            placeholder="value"
                            value={autofilledValueInstrumentTimePercent ? autofilledValueInstrumentTimePercent : ""}
                            disabled
                          />
                        </div>
                      </div>):
                      ( <div style={{ marginLeft: "25%" }}>
                         <p className="heading5">Instrument Time %</p>
                         <div
                           style={{
                             display: "flex",
                             alignItems: "center",
                             gap: "10px",
                           }}
                         >
                           <input
                             style={{ width: "50%" }}
                             className="add_group"
                             type="text"
                             placeholder="%"
                             onChange={handleInstrumentTimePercentageChange}
                             onBlur={
                               calculateAutofilledValueInstrumentTimePercent
                             }
                           />
                           <input
                             style={{ width: "50%" }}
                             className="add_group"
                             type="text"
                             placeholder="value"
                             value={autofilledValueInstrumentTimePercent ? autofilledValueInstrumentTimePercent : ""}
                             disabled
                           />
                         </div>
                       </div>
                      )}
        
                  </div>
                  <div
                    className="f-flex"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                      Out (UTC)
                    </label>
                    <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                      In (UTC)
                    </label>
                  </div>
                  <div className="f-flex">
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="+9:00"
                        className="add_input"
                        value={actualOff}
                        onChange={(e) => setActualOff(e.target.value)}
                      />
                    </div>
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="+12:00"
                        className="add_input"
                        value={actualOn}
                        onChange={(e) => setActualOn(e.target.value)}
                      />
                    </div>
                  </div>
                  <label
                      className="heading5"
                      style={{
                        marginBottom: "5px",
                        display: "flex",
                        flexGrow: "1",
                      }}
                    >
                     Remarks
                  </label>
                  <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1",height:"100px",width:"100%" }}
                    >
                      <textarea
                      style={{resize:"none",height: "80px"}}
                        placeholder="Enter your remarks"
                        className="add_input"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                      />
                    </div>
                </div>
              )}
              <div style={{ marginTop: "20px" }}>
                <button
                  type="button"
                  className="add_btn"
                  style={{ float: "right" }}
                  onClick={handleOpenPreview}
                >
                  <span>Preview Flight</span>
                </button>

                <PreviewModal
                  resetAllStates={resetAllStates}
                  open={isModalOpen}
                  onClosePr={handleClosePreview}
                  onCloseFm={handleCloseFlightModal}
                  flightId={flightId}
                  aircraftId={aircarftid}
                  selectedAircraft={selectedAircraft}
                  registrationNo={registrationNo}
                  aircraftType={aircraftType}
                  flightNumber={flightNumber}
                  fromLoc={fromLoc}
                  toLoc={toLoc}
                  date={date}
                  actualOut={actualOut}
                  actualIn={actualIn}
                  totalTime={totalTime}
                  day={day}
                  night={night}
                  landingDay={landingDay}
                  landingNight={landingNight}
                  approachesInput={approachesInput}
                  autofilledValueInstrumentTimePercent={
                    autofilledValueInstrumentTimePercent
                  }
                  takesOffDay={takesOffDay}
                  takesOffNight={takesOffNight}
                  crewOptionsPresent={crewOptionsPresent}
                  userInput={userInput}
                  actualOff={actualOff}
                  actualOn={actualOn}
                  route={route}
                  fromCity={fromCity}
                  toCity={toCity}
                  crossCountry={crossCountryTime}
                  routeDistance={routeDistance}
                  arrivalDelay={arrivalDelay}
                  departureDelay={departureDelay}
                />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </form>
        </Box>
      </Slide>
    </Modal>
  );
}

export default AddFlightModal;
